import React from 'react';
import './thermostat-icon.css';

export const ThermostatIcon = () => (
  <div className="thermostat-icon">&nbsp;</div>
);
